import { Box } from '@mui/material'
import { TemplateOutputsRunRateTable } from 'Features/Projects/Scenarios/Templates/TemplateResults/TemplateResults.types'
import { RunRateTable } from 'Features/Projects/Scenarios/Templates/TemplateResults/RunRate/RunRateTable'
import { PreferredMethod } from 'Features/Projects/Scenarios/Templates/PlanTemplateSummary.types'
import { useParams } from 'react-router-dom'
import { useUpdateRunRateTable } from 'Features/Projects/Scenarios/Templates/TemplateResults/TemplateResults.data'
import { useEffect, useState } from 'react'
import { LoadingButton } from '@mui/lab'
import SaveIcon from '@mui/icons-material/Save'
import { toast } from 'react-hot-toast'

type RunRateViewProps = {
  data: TemplateOutputsRunRateTable[]
  isLoading: boolean
  width: number
  height: number
}

type RunRateParams = {
  projectId: string
  scenarioId: string
  workcentreId: string
  preferredMethod: PreferredMethod
}

export const RunRateView = ({
  data,
  isLoading,
  width,
  height,
}: RunRateViewProps) => {
  const { projectId, scenarioId, workcentreId, preferredTemplate } =
    useParams<RunRateParams>() as {
      projectId: string
      scenarioId: string
      workcentreId: string
      preferredTemplate: PreferredMethod
    }

  const [tableRows, setTableRows] =
    useState<TemplateOutputsRunRateTable[]>(data)

  const onError = () => {
    toast.error('Save Failed')
  }

  const onSuccess = () => {
    toast.success('Save Successful')
  }

  const { mutate: updateCycles, isLoading: isUpdating } = useUpdateRunRateTable(
    onSuccess,
    onError
  )

  const saveChanges = () => {
    updateCycles({
      projectId,
      scenarioId,
      workcentreId,
      preferredMethod: preferredTemplate,
      updateData: tableRows,
    })
  }

  useEffect(() => {}, [])

  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        flex: 1,
        overflowY: 'auto',
      }}
      width={width}
      maxHeight={height - 100}
    >
      <Box display="flex" flexDirection="row" justifyContent="flex-start">
        <LoadingButton
          disabled={isUpdating}
          loading={isUpdating}
          onClick={saveChanges}
          startIcon={<SaveIcon />}
          loadingPosition="start"
        >
          <span>Save</span>
        </LoadingButton>
      </Box>
      <RunRateTable
        tableRows={tableRows}
        setTableRows={setTableRows}
        isLoading={isLoading || isUpdating}
      />
    </Box>
  )
}
